<div
    (click)="onClick()"
    [matTooltip]="!isCollapsed ? item.title : ''"
    matTooltipPosition="right"
    [class.centered]="!isCollapsed"
    [class.active]="item.isActive"
    [class.disabled]="item.disabled"
>
    <mat-icon>{{ item.icon }}</mat-icon>
    <mat-label *ngIf="isCollapsed">{{ item.title }}</mat-label>
</div>
